'use strict';

(function (slideContents, $win, checkSlideHeight, checkIfLoaded, debounce) {
    $win.addEventListener('resize', debounce(function () {
        return checkSlideHeight(slideContents);
    }, $win));

    document.addEventListener('DOMContentLoaded', function (event) {
        return checkIfLoaded(slideContents, checkSlideHeight, null, $win, true, 100);
    });

    $win.addEventListener('message', function (event) {
        if (event.data === 'repaint') checkIfLoaded(slideContents, checkSlideHeight, null, $win, true, 100);
    });
})(document.getElementsByClassName('content-slider'), window, function (slideContents) {
    [].forEach.call(slideContents, function (slideContent) {
        var slideHeight = slideContent.getBoundingClientRect().height;
        var offset = parseInt(slideContent.getAttribute('offset'));

        if (offset && offset > 0) {
            slideHeight = slideHeight > offset / 2 ? Math.abs(Math.ceil((slideHeight - offset) / 2)) : Math.abs(Math.ceil(offset / 2 - slideHeight));
            slideContent.style.marginBottom = '-' + slideHeight + 'px';
        } else slideContent.style.marginTop = '-' + slideHeight + 'px';
    });
}, function ($elements, $contFunction, previousHeight, $win, flagSwitch, iterationMax) {
    if ($elements === undefined) return;

    var checkIfLoaded = function checkIfLoaded($elements, $function, previousHeight, $win, flagSwitch) {
        if (flagSwitch) {
            var elemHeight = $elements[0].getBoundingClientRect().height;
            if (elemHeight === previousHeight) $function($elements);else window.requestAnimationFrame(function () {
                return checkIfLoaded($elements, $function, elemHeight, $win, !flagSwitch);
            });
        } else window.requestAnimationFrame(function () {
            return checkIfLoaded($elements, $function, previousHeight, $win, !flagSwitch);
        });
    };

    (function checkIfLoadedStarted($elements, $function, $win, iterationMax, iterationCount) {
        if (iterationCount < iterationMax) {
            if ($elements.length > 0) $function($elements, $contFunction, previousHeight, $win, flagSwitch);else $win.requestAnimationFrame(function () {
                return checkIfLoadedStarted($elements, $function, $win, iterationMax, iterationCount + 1);
            });
        } else console.debug('Why is the slide down JS being run when there are no slide downs?');
    })($elements, checkIfLoaded, $win, iterationMax, 0);
}, function (func, $win) {
    var timeout = void 0;
    return function () {
        if (timeout) $win.cancelAnimationFrame(timeout);
        timeout = $win.requestAnimationFrame(function () {
            func.apply(undefined);
            timeout = null;
        });
    };
});